import CrudCustom from '../../../libs/custom/CrudCustom';

let StatusPajakPenjualService = new CrudCustom('/status-pajak-penjuals');
export default StatusPajakPenjualService;
